<template>
	<div>
		<div class="row">
			<div class="col-md-6">
				<div class="input-group">
					<input
						type="text"
						:placeholder="$t('search-ellipses')"
						v-model="search.q"
						class="form-control form-control-lg"
						@keyup.enter="newSearch"
					/>
					<div class="input-group-append">
						<button class="btn btn-primary" type="button" @click="newSearch">
							<b-icon icon="search"></b-icon>
						</button>
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<div class="btn-group block">
					<a :class="{ btn: true, 'btn-light': showTemplates, 'btn-success': !showTemplates }" @click="setShowTemplates(false)">{{ $t('forms') }}</a>
					<a :class="{ btn: true, 'btn-light': !showTemplates, 'btn-success': showTemplates }" @click="setShowTemplates(true)">{{ $t('templates') }}</a>
				</div>
			</div>
			<div class="col-md-3">
				<button class="btn btn-primary btn-block btn-lg mb-3" @click="startNewForm">{{ $t("new-form") }}</button>
			</div>
		</div>

		<InfiniteScroll
			scrollElementId="main"
			type="Form"
			:dataUrl="`${$settings.APIBaseURL}/forms/list`"
			dataProperty="forms"
			class="list-group border-radius-2 no-border"
			itemClass="list-group-item"
			@selectItem="selectForm"
			ref="infinitescroll"
		/>
	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll";

export default {
	components: {
		InfiniteScroll
	},
	data() {
		return {
			search: {
				q: ""
			},
			showTemplates: false
		};
	},
	mounted() {
		this.getForms();
	},
	methods: {
		newSearch() {
			this.getForms();
		},
		setShowTemplates(value) {
			this.showTemplates = value;
			this.getForms();
		},
		getForms() {
			const body = {
				q: this.search.q ? this.search.q : "",
				templatesonly: this.showTemplates ? 1 : 0
			};
			this.$refs.infinitescroll.getData("replace", body);
		},
		selectForm(form) {
			this.$store.commit("showBlockingSpinner");
			this.$router.push(`/formeditor/form/${form.id}`);
		},
		// Offers a blank form, or starting from one of the existing templates. Picking a template
		// opens the form editor with the template's id, so the editor can load its settings into
		// the UI, clear the title and unset form_id - nothing is persisted until the user saves.
		startNewForm() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t('new-form'),
				selectCallback: function(choice) {
					if(choice.action === 'blank') {
						self.$store.commit("closeModal");
						self.$router.push('/formeditor/form');
					} else if(choice.action === 'template') {
						self.openTemplateSelector();
					}
				},
				selected: [],
				data: [
					{ action: 'blank', caption: this.$t('blank-form'), subcaption: this.$t('blank-form-help') },
					{ action: 'template', caption: this.$t('from-template'), subcaption: this.$t('from-template-help') }
				],
				captionKey: 'caption',
				subcaptionKey: 'subcaption'
			});
		},
		openTemplateSelector() {
			const self = this;
			this.$cfetch(`${this.$settings.APIBaseURL}/forms/list`, {
				data: { q: '', templatesonly: 1 }
			})
			.then(json => {
				if (json.status === 'SUCCESS') {
					self.$store.commit("openModal", {
						type: "selector",
						title: self.$t('choose-a-template'),
						selectCallback: function(selection) {
							self.createFormFromTemplate(selection.id);
						},
						selected: [],
						data: json.forms,
						captionKey: 'form_title',
						idProperty: 'id'
					});
				}
			})
			.catch(error => {
				this.$log.error.call(this, error);
			});
		},
		createFormFromTemplate(templateId) {
			this.$store.commit("closeModal");
			this.$store.commit("showBlockingSpinner");
			this.$router.push(`/formeditor/form?fromtemplate=${templateId}`);
		}
	},
	computed: {}
};
</script>
